<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'pagefooter',
})
</script>
<template>
  <div class="text-white pagefooter" v-if="siteinfo">
    <div class="auto-container">
    <a-row>
      <a-col  :span="6">
        <img  style="width:128px;height:128px;" v-if="siteinfo" :src="addip(siteinfo.weixincode)" :alt="siteinfo.title"  />
      </a-col>
      <a-col  :span="18">
        <ul class="nav-v">
          <li  class="nav-item" v-for="(item,i) in menu" :key="i">
            <div class="nav-title">{{ item.text }}</div>
            <ul class="nav-v">
                <li  class="nav-item" v-for="(it,u) in item.child" :key="u">
                    <div class="nav-title">{{ it.text }}</div>
                </li>
            </ul>
          </li>
        </ul>
      </a-col>
    </a-row>
    <div class="padding text-center flex align-center justify-center" style="flex-wrap: wrap;">
          <a href="https://beian.miit.gov.cn/"  class="padding flex-inline align-center text-white">
            <img src="@/assets/img/beian.png" style="width:28px;vertical-align:middle;margin-right:5px;" />
             {{siteinfo.beian}}
          </a>
            <div class="padding flex-inline">{{ siteinfo.title }}</div>
            <div class="padding flex-inline">{{siteinfo.email}}</div>
            <div class="padding flex-inline">{{siteinfo.address}}</div>
    </div>
    </div>
    </div>
</template>
<script setup lang="ts" name="pagefooter">
import { onMounted,ref,getCurrentInstance,nextTick,defineProps  } from 'vue';
import {addip} from '@/utils/util'
const props= defineProps({
  siteinfo:Object
})
const menu=ref<Array>([])

onMounted(()=>{
  const app=getCurrentInstance()
  const api=app?.appContext.config.globalProperties.$api
  api.global.footer().then(res=>{
    if(res.state==1){
      menu.value=res.data
    }
  })
})
</script>

<style lang="less">
  @menu-height:80px;
  @import '@/style/main.less';
    .pagefooter{
      width:100%;color:#fff;
       .nav-v{transform: scaleY(0);color:@white;
          flex-direction:column;overflow:hidden;transition:all .2s linear; transform-origin:0% 0%;

            .nav-item{
                .nav-title{height:50px;padding:10px;justify-content: flex-start;font-size: 1.1em;border-bottom: none;cursor: pointer;}
            }
        }
    }
</style>
